import { StrictMode } from 'react'
import './i18n'
import { createRoot, hydrateRoot } from 'react-dom/client'
import 'remixicon/fonts/remixicon.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/900.css'
import '@fontsource/noto-sans-jp/400.css'
import '@fontsource/noto-sans-jp/500.css'
import './index.css'
import App from './App.tsx'

const container = document.getElementById('root')!

const tree = (
  <StrictMode>
    <App />
  </StrictMode>
)

// ビルド出力にはプリレンダー済みの本文が入っている（scripts/prerender.mjs）。
// **そのときは hydrate して既存の DOM を再利用する。**
// createRoot で描くと React は中身を捨てて描き直すので、せっかく先に出ている本文が
// 一度消えて出直す＝ちらつく。
//
// `vite dev` では #root が空なので、その場合だけ通常の描画に落とす。
if (container.hasChildNodes()) {
  hydrateRoot(container, tree)
} else {
  createRoot(container).render(tree)
}
